import { MarginType } from 'common/types/styleTypes'
import { marginCss, mobileMarginCss } from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

type BaseEntityProps = {
  stateColor: string | null
  isSomethingDragging?: boolean
  isEditing: boolean
  margin?: MarginType
  mobileMargin?: Partial<MarginType>
  appearance?: {
    desktop: boolean
    mobile: boolean
  }
  flex?: boolean
  flexColumn?: boolean
}

const BaseEntityNewUi = styled.div<BaseEntityProps>`
  position: relative;
  ${p => p.flex && `display: flex;`};
  ${p => p.flexColumn && `flex-direction: column;`}
  ${p => p?.appearance?.desktop === false && `display: none`};
  ${p =>
    p.stateColor &&
    css`
      outline: 1px solid ${p.stateColor};
    `};
  ${p =>
    p.isSomethingDragging &&
    css`
      outline: 1px dashed #ccc;
    `}
  ${p =>
    p.isEditing &&
    css`
      box-shadow: 0 0 0 2px var(--default-blue-color);
    `};
  ${marginCss}
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileMarginCss};
      display: ${p?.appearance?.mobile === false ? 'none' : p.flex ? 'flex' : 'block'};
    `}
`

export default BaseEntityNewUi
